module.exports = {
  slots: [
    {
      slotId: 'menu-bar',
      components: [
        {
          widgetId: 'MenuBar',
          props: {
            second_set: [],
            first_set: [],
            logo_link: '/',
            color_theme: 'LIGHT',
            scroll_effect: false
          }
        }
      ]
    },
    {
      slotId: 'content',
      components: []
    },
    {
      slotId: 'right-col',
      components: []
    },
    {
      slotId: 'footer',
      components: [
        {
          widgetId: 'Footer',
          props: {
            items: [],
            regions: [],
            socialLinks: [],
            copyright: {
              text: ''
            }
          }
        }
      ]
    }
  ],
  templateSettings: {
    url: '',
    region: 'US',
    featured: false,
    start_date: '',
    end_date: '',
    event_name: 'Event Name',
    event_description: 'Event Description',
    event_location: 'Event Location',
    event_address: 'Event Address',
    background_image_url: 'https://ff-genesis-cdn.s3.amazonaws.com/faraday-future-ff-91/faraday-future-ff-91-eminence-hero-image.jpg',
    background_position: 'CENTER CENTER',
    background_scale: 'cover',
    social_share: [
      { url: 'https://www.linkedin.com/shareArticle?mini=true&url={page url}&title={article title}&summary={short description}', icon: 'ff-icon-social-linkedin' },
      { url: 'https://twitter.com/share?url={URL}&text={article title} @FaradayFuture', icon: 'ff-icon-social-twitter' },
      { url: 'https://www.facebook.com/sharer/sharer.php?u={URL}', icon: 'ff-icon-social-facebook' },
      { url: 'mailto:?subject={article title}&body={URL}', icon: 'ff-icon-mail' },
      { url: 'http://service.weibo.com/share/share.php?url={URL}&title={article title} @FaradayFuture&appkey=1343713053&pic=&searchPic=false', icon: 'ff-icon-social-weibo' },
      { url: '{URL}', icon: 'ff-icon-social-wechat' }
    ]
  }
};
